import { formatINR } from './format.js';

export interface OrderLine {
  name: string;
  slug: string;
  price: number;
  quantity: number;
}

export interface OrderMessageOptions {
  storeName: string;
  /** Origin of the storefront, used to link each saree. */
  siteUrl?: string;
}

export function buildOrderMessage(lines: OrderLine[], { storeName, siteUrl }: OrderMessageOptions): string {
  const origin = siteUrl?.replace(/\/+$/, '');
  const body = lines.map((line, i) => {
    const parts = [`${i + 1}. ${line.name}`, `   Qty ${line.quantity} × ${formatINR(line.price)}`];
    if (origin) parts.push(`   ${origin}/sarees/${line.slug}`);
    return parts.join('\n');
  });
  const total = lines.reduce((sum, l) => sum + l.price * l.quantity, 0);

  return [
    `Hello ${storeName}! I'd like to order:`,
    '',
    // Blank line between sarees so each one reads as its own block in the chat.
    body.join('\n\n'),
    '',
    `Total: ${formatINR(total)}`,
    '',
    'Please confirm availability and delivery details.',
  ].join('\n');
}

/** For sold-out sarees: ask the store about the piece or something like it. */
export function buildEnquiryMessage(
  saree: Pick<OrderLine, 'name' | 'slug'>,
  { storeName, siteUrl }: OrderMessageOptions,
): string {
  const origin = siteUrl?.replace(/\/+$/, '');
  return [
    `Hello ${storeName}! I love this saree, but it's sold out:`,
    '',
    saree.name,
    ...(origin ? [`${origin}/sarees/${saree.slug}`] : []),
    '',
    'Will it be restocked, or do you have something similar?',
  ].join('\n');
}

/** A plain chat link with no pre-filled order, e.g. for the footer. */
export function whatsappChatLink(phoneNumber: string, text?: string): string {
  const digits = phoneNumber.replace(/\D/g, '');
  return text ? whatsappLink(digits, text) : `https://wa.me/${digits}`;
}

export function whatsappLink(phoneNumber: string, text: string): string {
  const digits = phoneNumber.replace(/\D/g, '');
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}
